export const getHideCompleteAML = (state) => {
  return state.hideCompleteAML.hideCompleteAML || false;
};

export const getAMLQuestions = (state) => state.AML.questions;
